import React from "react";
import moment from "moment";
import { Image } from "antd";
// import styled from "styled-components";
// import UI from "../../../../../shared/Components/UI/js";
import { PatientProfilePlaceholderSvg } from "../../../../../icons/";
import IdentifyDocuments from "./IdentifyDocuments";

const PatientProfile = ({ patient }) => {
  return (
    <div className="border rounded-xl mt-6 font-medium">
      <div className="p-8 border-b flex items-center">
        <div className="w-32 3xl:w-36">
          {patient.personal_info.profile_picture ? (
            <Image
              className="rounded-full overflow-hidden"
              preview={false}
              src={patient.personal_info.profile_picture}
              fallback="data:image/png;base64,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"
            />
          ) : (
            <PatientProfilePlaceholderSvg />
          )}
        </div>
        <div className="ml-12 w-full">
          <div className="flex">
            <div>
              <div className="text-sm 3xl:text-lg text-gray-1200">
                Last Name
              </div>
              <div className="text-base 3xl:text-xl text-blue-300">
                {patient.personal_info.last_name || ""}
              </div>
            </div>
            <div className="ml-12 3xl:ml-16">
              <div className="text-sm 3xl:text-lg text-gray-1200">
                First Name
              </div>
              <div className="text-base 3xl:text-xl text-blue-300">
                {patient.personal_info.first_name || ""}
              </div>
            </div>
            <div className="ml-12 3xl:ml-16">
              <div className="text-sm 3xl:text-lg text-gray-1200">
                Middle Name
              </div>
              <div className="text-base 3xl:text-xl text-blue-300">
                {patient.personal_info.middle_name || ""}
              </div>
            </div>
            <div className="ml-12 3xl:ml-16">
              <div className="text-sm 3xl:text-lg text-gray-1200">Suffix</div>
              <div className="text-base 3xl:text-xl text-blue-300">
                {patient.personal_info.suffix || ""}
              </div>
            </div>
            <div className="ml-12 3xl:ml-16">
              <div className="text-sm 3xl:text-lg text-gray-1200">Nickname</div>
              <div className="text-base 3xl:text-xl text-blue-300">
                {patient.personal_info.nick_name || ""}
              </div>
            </div>
          </div>
          <div className="grid grid-flow-col gap-4 mt-6 text-sm 3xl:text-lg">
            <div className="flex">
              <div className="text-gray-1200">
                <div>Age</div>
                <div className="mt-1.5">Sex</div>
                <div className="mt-1.5">Date of Birth</div>
              </div>
              <div className="ml-12 3xl:ml-16 text-blue-300">
                <div className="mt-1.5">
                  {patient.personal_info?.age
                    ? `${patient.personal_info?.age} years`
                    : ""}
                </div>
                <div>{patient.personal_info?.sex || ""}</div>
                <div className="mt-1.5">
                  {moment(patient.personal_info?.dob).format("MMM D, YYYY") ||
                    ""}
                </div>
              </div>
            </div>
            <div className="flex">
              <div className="text-gray-1200">
                <div>Nationality</div>
                <div className="mt-1.5">Religion</div>
                <div className="mt-1.5">Civil Status</div>
              </div>
              <div className="ml-12 3xl:ml-16 text-blue-300">
                <div>{patient.personal_info?.nationality || ""}</div>
                <div className="mt-1.5">
                  {patient.personal_info?.religion || ""}
                </div>
                <div className="mt-1.5">
                  {patient.personal_info?.civil_status || ""}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="p-8 border-b">
        <div className="text-blue-300 text-base 3xl:text-xl">
          Occupation Information
        </div>
        {patient.personal_info.occupations.map((data) => (
          <div className="flex" key={data.id}>
            <ul className="text-sm 3xl:text-lg text-gray-1200">
              <li className="mt-4">Present job</li>
              <li className="mt-4">Industry</li>
              <li className="mt-4">Employer</li>
            </ul>
            <ul className="text-sm 3xl:text-lg text-blue-300 ml-8">
              <li className="mt-4">{data.occupation || "-"}</li>
              <li className="mt-4">{data.industry_name || "-"}</li>
              <li className="mt-4">{data.employer || "-"}</li>
            </ul>
          </div>
        ))}
      </div>
      <div className="p-8 border-b">
        <div className="text-blue-300 text-base 3xl:text-xl">
          Address Information
        </div>
        {patient.patient_address.map((address, index) => {
          return (
            <div className="flex mt-4" key={index}>
              <div className="text-sm 3xl:text-lg text-gray-1200 w-40">
                {address.type_code === "present" ? "Present" : "Permanent"}{" "}
                Address
              </div>
              <div className="text-sm 3xl:text-lg text-blue-300">
                {address.barangay_description
                  ? `${address.barangay_description} `
                  : ""}
                {address.city_description ? `${address.city_description} ` : ""}
                {address.state_province_description
                  ? `${address.state_province_description} `
                  : ""}
                {address.region ? `Region ${address.region} ` : ""}
                {address.country_name ? `${address.country_name} ` : ""}
                {address.zip_code ? `${address.zip_code} ` : ""}
              </div>
            </div>
          );
        })}
      </div>
      <div className="p-8 border-b">
        <div className="text-blue-300 text-base 3xl:text-xl">
          Contact Information
        </div>
        {patient.personal_info.patient_contacts.map((contact) => (
          <div className="flex mt-4" key={contact.id}>
            <div className="text-sm 3xl:text-lg text-gray-1200 w-40">
              {contact.type_code === "M" ? "Mobile Phone" : "Email Address"}
            </div>
            <div className="text-sm 3xl:text-lg text-blue-300">
              {contact.contact_details}
            </div>
          </div>
        ))}
      </div>
      <div className="p-8 border-b">
        <div className="text-blue-300 text-base 3xl:text-xl">
          Identify Documents
        </div>
        <div className="mt-4">
          <IdentifyDocuments
            documents={patient.personal_info.patient_identifiers}
          />
          {/* {patient.personal_info.patient_identifiers.length > 0 ? (
            <div></div>
          ) : (
            <div className="h-36 flex items-center justify-center">
              <FlexBox>
                <Avatar
                  size={{
                    xs: 24,
                    sm: 32,
                    md: 40,
                    lg: 64,
                    xl: 80,
                    xxl: 100,
                  }}
                  src={UI.NO_INFO}
                />
                <NoDataText>NO DATA AVAILABLE YET</NoDataText>
              </FlexBox>
            </div>
          )} */}
        </div>
      </div>
      <div className="p-8 border-b">
        <div className="text-blue-300 text-base 3xl:text-xl">
          Contact in Case of Emergency
        </div>
        {patient.personal_info.emergency_contacts.map((contact) => (
          <div className="flex justify-between" key={contact.id}>
            <div className="flex">
              <ul className="text-sm 3xl:text-lg text-gray-1200">
                <li className="mt-4">Contact Person Name</li>
                <li className="mt-4">Relationship</li>
              </ul>
              <ul className="text-sm 3xl:text-lg text-blue-300 ml-8">
                <li className="mt-4">
                  {contact.prefix ? contact.prefix + " " : ""}
                  {contact.first ? contact.first + " " : ""}
                  {contact.middle ? contact.middle + " " : ""}
                  {contact.last ? contact.last + " " : ""}
                  {contact.suffix ? contact.suffix + " " : ""}
                </li>
                <li className="mt-4">{contact.relationship_uid_name || "-"}</li>
              </ul>
            </div>
            <div className="flex">
              <ul className="text-sm 3xl:text-lg text-gray-1200">
                <li className="mt-4">Purpose</li>
                <li className="mt-4">Contact Number</li>
              </ul>
              <ul className="text-sm 3xl:text-lg text-blue-300 ml-8">
                <li className="mt-4">{contact.purpose_uid_name || "-"}</li>
                <li className="mt-4">{contact.contact_number || "-"}</li>
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PatientProfile;

// const FlexBox = styled(Row)`
//   display: flex;
//   align-items: center;
//   justify-content: center;
// `;

// const NoDataText = styled(Typography.Paragraph)`
//   font-family: Poppins;
//   font-weight: 500; //medium
//   font-size: 1.125rem; // 18px
//   line-height: 1.4375rem; // 23px
//   letter-spacing: 0;
//   color: #b6b6b6;
//   margin-left: 10px;
//   margin-top: 20px;
// `;
